export default __webpack_public_path__ + "static/media/calendar.8c5c8e03.svg";